import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import axios from "axios";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Bangkok");

axios.defaults.withCredentials = true;

const container = document.getElementById("root");
const root = createRoot(container);
const userAgent = navigator.userAgent;

const isMobileDevice = () => {
  const regexs = [
    /(Android)(.+)(Mobile)/i,
    /BlackBerry/i,
    /iPhone|iPod/i,
    /Opera Mini/i,
  ];
  return regexs.some((b) => userAgent.match(b));
}

const isMobile = isMobileDevice();
if (isMobile){
  localStorage.setItem("isMobile", isMobile);
}else {
  localStorage.setItem("isMobile", false);
}

// Android → Web callback handlers.
// Android calls these via webView.evaluateJavascript() for network and lifecycle events.
// Safe no-ops when running in a regular browser.
window.ExamCallback = {
  onNetworkWarning: function(pingMs) {
    console.warn('[ExamBPPP] Jaringan lambat:', pingMs, 'ms');
  },
  onNetworkDisconnected: function() {
    console.error('[ExamBPPP] Jaringan terputus');
  },
  onNetworkRestored: function() {
    console.info('[ExamBPPP] Jaringan pulih');
  },
  onReturnFromBackground: function() {
    console.warn('[ExamBPPP] Kembali dari background — sesi akan direset oleh aplikasi');
  }
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
